import { createFileRoute } from "@tanstack/react-router";
import { ProfileSettings } from "@/features/settings/profile";

export const Route = createFileRoute("/_app/settings/profile")({
  head: () => ({ meta: [{ title: "Profile · Settings · Malfak" }] }),
  component: ProfileSettings,
});
